<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Solicitação de Exames"
    >
        <List
            v-if="layout === 'list'"
            :data="data"
            @edit="handleEdit"
        />

        <Form
            v-else
            :data="data"
            :model="model"
            @saved="saved"
            ref="Form"
            style="margin-top: -1rem; margin-bottom: -1rem;"
        />

        <template v-slot:footer="{ cancel }">
            <template v-if="layout === 'list'">
                <rkm-button @click="cancel">
                    Fechar
                </rkm-button>

                <rkm-button
                    @click="handleCreate"
                    :disabled="!!data.form.pedidosExames.find(p => isNaN(p.id))"
                    color="primary"
                >
                    Solicitar Exame
                </rkm-button>
            </template>

            <template v-else>
                <rkm-button @click="layout = 'list'">
                    Voltar
                </rkm-button>

                <rkm-button
                    @click="handleSave"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

export default {
    components: { Form, List },
    data: () => ({
        layout: null,
        model: null,
    }),
    methods: {
        open() {
            this.layout = 'list'
            this.$refs.RkmModal.show()
        },
        handleCreate() {
            this.model = Object.assign({}, {
                id: null,
                lotacao: {
                    ocupacao: {
                        codigo: this.data.form.lotacao.ocupacao.codigo,
                    },
                    profissional: {
                        nome: this.data.form.lotacao.profissional.nome,
                    },
                },
                exames: [],
                urgente: false,
                justificativa: null,
                exame: null,
            })

            this.data.form.kits.map(k => k.exames.map(e => e.checked = false))

            this.layout = 'form'
        },
        handleEdit(item) {
            this.model = Object.assign({}, {
                id: item.id,
                lotacao: {
                    ocupacao: {
                        codigo: item.lotacao.ocupacao.codigo,
                    },
                    profissional: {
                        nome: item.lotacao.profissional.nome,
                    },
                },
                exames: item.exames,
                urgente: item.urgente,
                justificativa: item.justificativa,
                exame: null,
            })

            this.data.form.kits.map(k => k.exames.map(exame => {

                exame.checked = !!this.model.exames.find(e => e.id === exame.id)
            }))

            this.layout = 'form'
        },
        handleSave() {
            this.$refs.Form.save()
        },
        saved() {
            this.layout = 'list'
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>